import { useEffect, useState } from "react";
import RestAPI from "../utils/restAPI";
import SharedUtils from "../shared/common/SharedUtils";
import { logDebug } from "../shared/common/logger";
interface VeriskData {
	input_description_lineNoSpaces: string;
	input_description: string;
	confidence: string;
	similarity_score: number;
	CAT: string;
	SEL: string;
	matched_description: string;
	UNIT: string;
	id: string;
	line_number: number;
	action: string;
}
const VeriskMappingTool = () => {
	const [dataToShow, setDataToShow] = useState<VeriskData[]>([]);
	const [finalData, setFinalData] = useState<VeriskData[]>([]);
	const [totalApproved, setTotalApproved] = useState(0);
	const [totalRejected, setTotalRejected] = useState(0);
	const [totalBadCombo, setTotalBadCombo] = useState(0);
	const [totalIgnored, setTotalIgnored] = useState(0);
	const [totalLines, setTotalLines] = useState(0);
	const [badComboCatMap, setBadComboCatMap] = useState<any>({});
	const [colSort, setColSort] = useState("input_description");
	const [colSortDir, setColSortDir] = useState(true);

	function setDataToShowWithSorting(data: VeriskData[]) {
		const sortedData = data.sort((a: any, b: any) => {
			// logDebug('colSort', colSort);
			if (colSortDir) {
				if (a[colSort] > b[colSort]) {
					return 1;
				}
				if (a[colSort] < b[colSort]) {
					return -1;
				}
			} else {
				if (a[colSort] < b[colSort]) {
					return 1;
				}
				if (a[colSort] > b[colSort]) {
					return -1;
				}
			}
			return 0;
		});
		setDataToShow([...sortedData]);
		// logDebug('sortedData', sortedData.map((item: any) => item[colSort]));
	}
	async function refreshData() {
		// TODO: removed dev-utils endpoints — Verisk data loading no longer available
		console.warn("Verisk data loading is no longer available (dev-utils removed)");
	}
	useEffect(() => {
		refreshData();
	}, []);

	useEffect(() => {
		// logDebug('colSort', colSort);
		setDataToShowWithSorting(dataToShow);
	}, [colSort, colSortDir]);

	function addAction(id: string, action: string) {
		const newData = dataToShow.map((item) => {
			if (item.id === id) {
				if (item.action === "Approve") {
					setTotalApproved(totalApproved - 1);
				}
				if (item.action === "Reject") {
					setTotalRejected(totalRejected - 1);
				}
				if (item.action === "Ignore") {
					setTotalIgnored(totalIgnored - 1);
				}
				if (item.action === "BadCombo") {
					setTotalBadCombo(totalBadCombo - 1);
				}
				item.action = action;
				if (action === "Approve") {
					setTotalApproved(totalApproved + 1);
				}
				if (action === "Reject") {
					setTotalRejected(totalRejected + 1);
				}
				if (action === "Ignore") {
					setTotalIgnored(totalIgnored + 1);
				}
				if (action === "BadCombo") {
					setTotalBadCombo(totalBadCombo + 1);
				}
			}
			return item;
		});
		setDataToShow(newData);
	}

	async function saveData() {
		// TODO: removed dev-utils endpoint — noteOnVeriskData no longer available
		console.warn("Verisk data saving is no longer available (dev-utils removed)");
	}

	logDebug("rendering with dataToShow", badComboCatMap);

	return (
		<div>
			<h1 className="p-1  m-1">Verisk Mapping Tool</h1>
			{dataToShow.length === 0 && <p>Loading...</p>}
			{dataToShow.length > 0 && (
				<div>
					<div className="flex">
						<div className="p-1 bg-gray-200 mx-1">Total Lines: {totalLines}</div>
						<div className="p-1 bg-gray-200 mx-1">Total Approved: {totalApproved}</div>
						<div className="p-1 bg-gray-200 mx-1">Total Rejected: {totalRejected}</div>
						<div className="p-1 bg-gray-200 mx-1">Total Ignored: {totalIgnored}</div>
						<div className="p-1 bg-gray-200 mx-1">Total Bad Combo: {totalBadCombo}</div>
						<div className="p-1 bg-gray-200 mx-1">
							Total Left: {totalLines - totalApproved - totalRejected - totalIgnored - totalBadCombo}
						</div>
					</div>
					<div className="flex m-1 items-center">
						Bad Combo CATs (updated only after refresh):{" "}
						{Object.keys(badComboCatMap || {}).map((key) => {
							return (
								<div className="p-1 bg-gray-100 mx-1">
									{key}: {badComboCatMap[key]}
								</div>
							);
						})}
					</div>
					<div className="flex items-center">
						<div className={`mx-2 bg-green-100 btn p-1 rounded  w-40 m-4 justify-center flex`} onClick={saveData}>
							Save & Refresh Data
						</div>
						<input type="checkbox" className="mx-2" onClick={() => setColSortDir(!colSortDir)} checked={colSortDir} /> Sort
						Descending
						{/* <div className='mx-2 bg-red-100 p-1 rounded btn w-32 m-4 justify-center flex' onClick={refreshData}></div> */}
					</div>
					<table className="border">
						<thead>
							<tr>
								<th className="border p-2 cursor-pointer" onClick={() => setColSort("input_description")}>
									Input Description
								</th>
								<th className="border p-2 cursor-pointer" onClick={() => setColSort("matched_description")}>
									Matched Description
								</th>
								<th className="border p-2 cursor-pointer" onClick={() => setColSort("confidence")}>
									Confidence
								</th>
								<th className="border p-2 cursor-pointer" onClick={() => setColSort("CAT")}>
									CAT
								</th>
								<th className="border p-2 cursor-pointer" onClick={() => setColSort("SEL")}>
									SEL
								</th>
								{/* <th className='border p-2'>id</th> */}
								<th className="border p-2">Actions</th>

								{/* <th className='border p-2'>Line</th> */}
							</tr>
						</thead>
						<tbody>
							{dataToShow.map((item, index) => (
								<>
									<tr
										key={item.input_description_lineNoSpaces}
										className={`${item.action === "Approve" && "bg-green-50"}  ${
											item.action === "Reject" && "bg-red-50"
										} ${item.action === "Ignore" && "bg-cyan-50"} ${item.action === "BadCombo" && "bg-pink-50"}`}
									>
										<td className="border p-2">{item.input_description}</td>
										<td className="border p-2">{item.matched_description}</td>
										<td className="border p-2">{item.confidence}</td>
										<td className="border p-2">{item.CAT}</td>
										<td className="border p-2">{item.SEL}</td>
										{/* <td className='border p-2'>{item.id}</td> */}
										<td className="border p-2 flex justify-between">
											<div
												className="mx-2 bg-green-100 p-1 rounded btn"
												onClick={() => addAction(item.id, "Approve")}
											>
												Approve
											</div>
											<div className="mx-2 bg-red-100 p-1 rounded  btn" onClick={() => addAction(item.id, "Reject")}>
												Reject
											</div>
											<div className="mx-2 bg-cyan-100 p-1 rounded  btn" onClick={() => addAction(item.id, "Ignore")}>
												Ignore
											</div>
											<div
												className="mx-2 bg-pink-100 p-1 rounded  btn"
												onClick={() => addAction(item.id, "BadCombo")}
											>
												BC
											</div>
											<div className="mx-2 bg-gray-100 p-1 rounded  btn" onClick={() => addAction(item.id, "")}>
												Reset
											</div>
										</td>
										{/* <td className='border p-2'>{item.line_number}</td> */}
									</tr>
								</>
							))}
						</tbody>
					</table>
					<div className="h-16" />
				</div>
			)}
			<h2>
				Final Data Preview: {/* TODO: removed dev-utils download link */}
			</h2>
			<textarea className="w-full h-64 border" value={JSON.stringify(finalData.slice(0, 10), null, 2)} readOnly></textarea>
		</div>
	);
};

export default VeriskMappingTool;

const VeriskMappingView = () => {
	const [jsonData, setJsonData] = useState<any>(null);
	const [error, setError] = useState("");
	const handleFileUpload = (event: any) => {
		const file = event.target.files[0];
		setError("");
		setJsonData(null);

		if (!file) {
			setError("No file selected.");
			return;
		}

		if (file.type !== "application/json") {
			setError("Please select a valid JSON file.");
			return;
		}

		const reader = new FileReader();

		reader.onload = (e) => {
			try {
				// @ts-ignore
				const parsedData = JSON.parse(e.target.result);
				if (parsedData.meta && parsedData.meta.tuppleId) {
					setJsonData(parsedData);
				} else {
					setError("Invalid JSON file.");
				}
			} catch (err) {
				setError("Invalid JSON file.");
			}
		};

		reader.onerror = () => {
			setError("Error reading file.");
		};

		reader.readAsText(file);
	};
	return (
		<div>
			<h1>Verisk Mapping View</h1>
			<input type="file" accept=".json" onChange={handleFileUpload} />
			{error && <p>{error}</p>}
			{jsonData && (
				<table className="border">
					<tr>
						<td className="border p-2">Tupple Id</td>
						<td className="border p-2">{jsonData.meta.tuppleId}</td>
					</tr>
					<tr>
						<td className="border p-2">Full Image</td>
						<td className="border p-2">
							<img src={`data:image/png;base64,${jsonData.meta.full}`} />
						</td>
					</tr>
					<tr>
						<td className="border p-2">Left Image</td>
						<td className="border p-2">
							<img src={`data:image/png;base64,${jsonData.meta.left}`} />
						</td>
					</tr>
					<tr>
						<td className="border p-2">Right Image</td>
						<td className="border p-2">
							<img src={`data:image/png;base64,${jsonData.meta.right}`} />
						</td>
					</tr>
					<tr>
						<td className="border p-2">Unused Words</td>
					</tr>
					{jsonData.unusedWords?.map((w: any, i: number) => {
						return (
							<tr key={i}>
								<td className="border p-2">
									<img src={`data:image/png;base64,${w.regionImage}`} />
								</td>
								<td className="border p-2 flex">
									<span className="mx-2 border px-2">scan: {w.word}</span>
									<span className="mx-2 border px-2">confidence: {w.confidence}</span>
								</td>
							</tr>
						);
					})}
					<tr>
						<td className="border p-2">Available Mappings</td>
						<td className="border p-2">{jsonData.availableKeysWithMapping.join()}</td>
					</tr>
					<tr>
						<td className="border p-2">Data Preview</td>
						<td className="border p-2">
							{[jsonData].map((data) => {
								const copy = JSON.parse(JSON.stringify(data));
								copy.meta.full = "base64 image";
								copy.meta.left = "base64 image";
								copy.meta.right = "base64 image";

								return <textarea className="w-full h-64 border" value={JSON.stringify(copy, null, 2)} readOnly></textarea>;
							})}
						</td>
					</tr>
				</table>
			)}
		</div>
	);
};

export { VeriskMappingView };
